import { sva } from 'styled-system/css';

const modal = sva({
  slots: ['modal', 'backdrop'],
  base: {
    modal: {
      backgroundColor: 'gray-4',
      maxWidth: 'maxContainer',
      mx: 'auto',
      minHeight: '100px',
      maxHeight: '90dvh',
      overflowY: 'auto',
      overscrollBehavior: 'contain',
      scrollbar: 'hidden',
      position: 'fixed',
      zIndex: 'modal',
      borderRadius: '30px 30px 0 0 ',
      transition: 'all .3s',
      left: 0,
      right: 0,
      bottom: 0,
    },
    backdrop: {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: 'black-5',
      zIndex: 'modal',
      transition: 'all .4s',
      opacity: 0,
    },
  },
  variants: {
    open: {
      true: {
        modal: {
          transform: 'translateY(0)',
        },
        backdrop: {
          opacity: 1,
        },
      },
      false: {
        modal: {
          transform: 'translateY(100%)',
        },
      },
    },
    fullHeight: {
      true: {
        modal: {
          minHeight: '90dvh',
        },
      },
    },
  },
});
export default modal;
